import React, { useEffect } from 'react';
import { Coffee, Leaf, Star, ThermometerSun, Heart, BadgeCheck } from 'lucide-react';
import UseCaseTemplate from '../../components/UseCaseTemplate';

const HERO_IMG = 'https://customer-assets.emergentagent.com/job_use-cases-launch/artifacts/7bs8lcsn_coffeeroasters.jpg';

const CoffeeProducers = () => {
  useEffect(() => {
    document.title = 'Coffee Producers | Use Cases | Magomeal';
  }, []);

  const benefits = [
    {
      icon: <Coffee size={28} />,
      title: 'Coffee-First Design',
      description: 'Edible cups engineered specifically to hold espresso and hot specialty coffee for 40+ minutes without leaking.',
    },
    {
      icon: <Star size={28} />,
      title: 'Signature Tasting',
      description: 'Add a wafer-cookie note that complements your roast profile and elevates cuppings, festivals and tastings.',
    },
    {
      icon: <ThermometerSun size={28} />,
      title: 'Hot & Cold Ready',
      description: 'Suitable for espresso, cappuccino, cold brew and iced specialties – one cup format for every menu.',
    },
    {
      icon: <Leaf size={28} />
      ,
      title: '100% Natural',
      description: 'Made from natural grains and coconut oil. Vegan, GMO-free, no chemicals, no plastics, no waste.',
    },
    {
      icon: <BadgeCheck size={28} />,
      title: 'Brand Story Boost',
      description: 'Strengthen your sustainability narrative for retailers, hospitality clients and direct-to-consumer fans.',
    },
    {
      icon: <Heart size={28} />,
      title: 'Customer Delight',
      description: 'Turn every cup into a moment of surprise that customers share, photograph and remember.',
    },
  ];

  return (
    <UseCaseTemplate
      eyebrow="Use Case"
      title="Coffee Producers"
      subtitle="Pair premium coffee with edible cups for a signature, zero-waste experience."
      heroImage={HERO_IMG}
      imageAlt="Probat coffee roaster with freshly roasted beans"
      intro="Roasters, specialty coffee brands and direct-trade producers are looking for new ways to differentiate their craft – not just in the cup, but around it. Magomeal’s Cupffee edible cups complement premium coffee with a subtle wafer-cookie pairing that holds hot drinks beautifully and disappears with the last sip. The result: a unique tasting moment, less packaging waste, and a stronger sustainability story for your brand."
      benefitsTitle="Built for specialty coffee"
      benefitsSubtitle="Performance, taste and sustainability – in every cup."
      benefits={benefits}
      ctaTitle="Co-create a signature edible cup experience"
      ctaText="From cuppings and trade fairs to retail bundles – let’s design something memorable for your roastery or brand."
      primaryCta={{ label: 'Partner with Us', to: '/contact' }}
      secondaryCta={{ label: 'See Edible Cups', to: '/edible-cups' }}
    />
  );
};

export default CoffeeProducers;
